export default "__VITE_PUBLIC_ASSET__7a30ef83__"